export const findDifferenceIndex = (str1, str2) => {
    const minLength = Math.min(str1.length, str2.length);

    for (let i = 0; i < minLength; i++) {
        if (str1[i] !== str2[i]) {
            return i; // Return the index where the strings differ
        }
    }

    return minLength; // If the strings are equal up to the minimum length, return the minimum length
};

export function compareStrings(str1, str2) {
    const oldSpaceCount = (str1.match(/ /g) || []).length;
    const newSpaceCount = (str2.match(/ /g) || []).length;

    // If the new string has exactly one more space than the old string, return true
    if (newSpaceCount === oldSpaceCount + 1) {
        return true;
    }

    if (str1.length > str2.length) {
        return true;
    }

    // Iterate through each character in the new string
    for (let i = 0; i < str2.length; i++) {
        // If characters are different
        if (str1[i] !== str2[i]) {
            // Check if the differing character is an alphabet
            if (/^[a-zA-Z]$/.test(str2[i])) {
                return false; // It is not an alphabet, return false
            }
        }
    }

    // If all characters are the same or alphabets, return true
    return true;
}
